import { useQuery } from "@apollo/client";
import { GET_ANNOUNCEMENTS } from "./graphql";
import { Announcement } from "../../__generated__/graphql";
import { useParams } from "react-router-dom";
import { PageContainer } from "../../components/PageContainer";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { LinkButton } from "../../components/LinkButton";
import { LoadingOverlay } from "../../components/Loading";
import dayjs from "dayjs";

export const Announcements = () => {
  const { editionId } = useParams();
  const { data, loading } = useQuery(GET_ANNOUNCEMENTS, {
    skip: !editionId,
    variables: {
      editionId: editionId!,
    },
  });

  if (!data) return null;

  return (
    <PageContainer title="Announcements">
      <LinkButton
        path={`/announcement/edit/${editionId}`}
        text="Create"
        variant="contained"
      />
      <LoadingOverlay loading={loading}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">name</TableCell>
                <TableCell align="left">announcement date</TableCell>
                <TableCell align="left">actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.announcements.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="left">{row.name}</TableCell>
                  <TableCell align="left">{dayjs(row.availabilityDate).format("YYYY/MM/DD HH:mm")}</TableCell>
                  <TableCell align="left">
                    <LinkButton path={`/announcement/${row.id}`} text="Bands" />
                    <LinkButton
                      path={`/announcement/edit/${editionId}/${row.id}`}
                      text="Edit"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </LoadingOverlay>
    </PageContainer>
  );
};
